let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kyveB")).then(() => parcelRequire('726mc'));